export const DATE_FORMAT = "DD/MM/YYYY"

// Adresse e-mail : l'extension du domaine peut dépasser 3 lettres (.info, .email,
// .brussels…) et la partie locale peut contenir un « + » (alias Gmail).
export const EMAIL_PATTERN = /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/
